module.exports = __webpack_public_path__ + "static/img/banner-3.105ffa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/banner-3.jpg
// module id = Wz/j
// module chunks = 1